import { render } from "./ProyectoArchivoTipoList.vue?vue&type=template&id=50d049a4&scoped=true"
import script from "./ProyectoArchivoTipoList.vue?vue&type=script&lang=js"
export * from "./ProyectoArchivoTipoList.vue?vue&type=script&lang=js"

import "./ProyectoArchivoTipoList.vue?vue&type=style&index=0&id=50d049a4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d049a4"]])

export default __exports__